import { taskIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { loadTask } from "../tasks/loaders.ts";
import { RecordPending } from "../tasks/pending.tsx";
import { TaskPage } from "../tasks/task-page.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/tasks/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null ? <NoAccessPage /> : <TaskPage viewer={viewer} taskId={id} />;
};

export const Route = createFileRoute("/_app/tasks/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(taskIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadTask(context.data, params.id),
  pendingComponent: () => <RecordPending kind="task" />,
  component: Page,
});
